<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentInfoListByShipmentApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
